import React from 'react'
import '../Navbar.css'

function Navbar() {
    return (
        <div className="navbar is-fixed-top" role="navigation" aria-label="main navigation">
            <div className="container">
                <div className="navbar-brand">
                    <a className="navbar-item" href="/">
                        <span className="icon"><i className="fab fa-twitter"></i></span>
                    </a>
                </div>
                    {/* <div id="navbar"> */}
                <div id="search" className="field navbar-item">
                    <p className="control has-icons-left">
                        <input className="input" type="text" placeholder="Search" />
                        <span className="icon is-small is-left"><i className="fas fa-search"></i></span>
                    </p>
                </div>
                    <a className="navbar-item">
                        <div className="button is-small is-primary">
                            Sign in
                        </div>
                    </a>
                    <a className="navbar-item">
                        <div className="button is-small">
                            Sign up
                        </div>
                    </a>
                {/* </div> */}
            </div>
        </div>
    )
}

export default Navbar